<template>
  <pt-lab-test-platform-table class="pt-lab-test-platform-table__withData" ref="table" :request-data="getDataList" :page-size="pageSize"
  :total-number="Number(totalNumber)" :table-data="tableData" :tableLabels="tableLabels">
    <template slot-scope="scope">
      <slot :row="scope.row"></slot>
    </template>
  </pt-lab-test-platform-table>
</template>

<script>
import PtLabTestPlatformTable from './index'
export default {
  name: 'pt-lab-test-platform-table__withData',
  components: {
    'pt-lab-test-platform-table': PtLabTestPlatformTable
  },
  props: {
    tableLabels: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      pageSize: 10,
      totalNumber: 0,
      tableData: [],
      currentParams: {}
    }
  },
  methods: {
    buildFilterParams (page, params = {}) {
      if (Object.keys(params).length) {
        params.pageableParam['page'] = page
        params.pageableParam['size'] = this.pageSize
        return params
      } else {
        return {
          example: { organizationRole: 'LAB' },
          pageableParam: { page: page, size: this.pageSize, sort: ['createdDate,desc'] }
        }
      }
    },
    getDataList (page, next) {
      let data = this.buildFilterParams(page, this.currentParams)
      this.$store.dispatch('labTestPlatformList', data).then(res => {
        next(res.data)
        this.tableData = res.data
        this.totalNumber = res.totalNumber
        this.$emit('getAllSize', this.totalNumber)
      }).catch(err => {
        this.$refs.table.showReTry()
        this.$message.error(err)
      })
    },
    // 筛选数据的参数,不传默认为{}
    reload (params = {}) {
      this.currentParams = params
      this.$refs.table.reload()
    }
  }
}
</script>
